import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import "./adminProfile.css";
import { clearData } from "../../../utils/localStorage";
import SideBar from "../../commanComponents/sidebar/sidebar";
import PrimaryButton from '../../commanComponents/primaryButton/primaryButton';
import TopNavigation from "../../commanComponents/topNavigation/topNavigation";
import { getSchoolAdminProfileService } from "../../../modules/services";
import { ROUTES, sidebarNavItems } from "../../../constant";
import SkeletonLoading from '../../commanComponents/skeletonLoading/skeletonLoading';
import LogoutModal from '../../auth/logout/logout';
import { titleCase } from "../../../utils/utils"; 


const Profile = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [logoutModal, setshowLogoutModal] = useState(false);
    const [data, setData] = useState(false);


    useEffect(() => {

        (async () => {
            const responseData = await getSchoolAdminProfileService({});
            if (responseData !== "error" && (responseData.status_code === 200 || responseData.status_code === 201)) {
                setData(responseData.data);
                setIsLoading(false);
            }
            else if(responseData !== "error" && (responseData.status_code !== 200 || responseData.status_code !== 201)) {
                setIsLoading(false);
            }
            else {
                clearData();
                navigate(ROUTES.LOGIN);
            }
        })();

    }, [navigate]);
    
    const handleLogoutButton = () => {
        setshowLogoutModal(true);
    }

    const handleCloseLogoutModal = () => setshowLogoutModal(false);

    const handleEditButton = () => { 
        navigate(ROUTES.ADMIN_EDIT_PROFILE);
    }

    const handleChangePasswordButton = () => {
        navigate(ROUTES.ADMIN_CHANGE_PASSWORD);
    }

    return (
        <div className='profile-container' style={{ display: 'flex' }}>
            {LogoutModal({logoutModal, handleCloseLogoutModal})}
            <SideBar activeItem={sidebarNavItems.profile} />
            <div className='profile-side-container'>

                <TopNavigation activeItem={sidebarNavItems.profile} />
                
                <div className='row profile-filter-container'>
                    <div className='profile-filter-inner-div'>
                        <PrimaryButton
                            text="Logout"
                            isLoading={isLoading}
                            onClick={handleLogoutButton}
                        />
                    </div>
                </div>
                
                <div className='profile-main-container'>
                    <div className='row'>
                        <div className='col'>
                        <h5>Personal Details</h5>
                        </div>
                        <div className='col profile-header-right'>
                            <PrimaryButton
                                text="Edit"
                                isLoading={isLoading}
                                onClick={handleEditButton}
                            />
                        </div>
                    </div>
                    
                    <hr className="profile-border" />
                    <div className='row'>
                        <div className='col'>
                            <div className='row'>
                                <div className='col-sm-4'>
                                    <label className='profile-label'>First Name</label>
                                </div>
                                <div className='col'>
                                    <label className='profile-value'>{isLoading ? <SkeletonLoading customStyle={{width: "150px"}}/> : data.first_name ? data.first_name :<span>N/A</span>}</label>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-4'>
                                    <label className='profile-label'>Email</label>
                                </div>
                                <div className='col'>
                                    <label className='profile-value'>{isLoading ? <SkeletonLoading customStyle={{width: "150px"}}/> : data.email ? data.email :<span>N/A</span>}</label>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-4'>
                                    <label className='profile-label'>Gender</label>
                                </div>
                                <div className='col'>
                                    <label className='profile-value'>{isLoading ? <SkeletonLoading customStyle={{width: "150px"}}/> : data.gender ? titleCase(data.gender) :<span>N/A</span>}</label>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-4'>
                                    <label className='profile-label'>State</label>
                                </div>
                                <div className='col'>
                                    <label className='profile-value'>{isLoading ? <SkeletonLoading customStyle={{width: "150px"}}/> : data.state ? data.state :<span>N/A</span>}</label>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-4'>
                                    <label className='profile-label'>Pin code</label>
                                </div>
                                <div className='col'>
                                    <label className='profile-value'>{isLoading ? <SkeletonLoading customStyle={{width: "150px"}}/> : data.pincode ? data.pincode :<span>N/A</span>}</label>
                                </div>
                            </div>
                        </div>
                        <div className='col'>
                            <div className='row'>
                                <div className='col-sm-4'>
                                    <label className='profile-label'>Last Name</label>
                                </div>
                                <div className='col'>
                                    <label className='profile-value'>{isLoading ? <SkeletonLoading customStyle={{width: "150px"}}/> : data.last_name ? data.last_name :<span>N/A</span>}</label>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-4'>
                                    <label className='profile-label'>Phone no</label>
                                </div>
                                <div className='col'>
                                    <label className='profile-value'>{isLoading ? <SkeletonLoading customStyle={{width: "150px"}}/> : data.phone ? data.phone :<span>N/A</span>}</label>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-4'>
                                    <label className='profile-label'>Date of Birth</label>
                                </div>
                                <div className='col'>
                                    <label className='profile-value'>{isLoading ? <SkeletonLoading customStyle={{width: "150px"}}/> : data.dob ? data.dob :<span>N/A</span>}</label>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-4'>
                                    <label className='profile-label'>City</label>
                                </div>
                                <div className='col'>
                                    <label className='profile-value'>{isLoading ? <SkeletonLoading customStyle={{width: "150px"}}/> : data.city ? data.city :<span>N/A</span>}</label>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-4'>
                                    <label className='profile-label'>Country</label>
                                </div>
                                <div className='col'>
                                    <label className='profile-value'>{isLoading ? <SkeletonLoading customStyle={{width: "150px"}}/> : data.country ? data.country :<span>N/A</span>}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='profile-main-container'>
                    <h5>Academic Details</h5>
                    <hr className="profile-border" />
                    <div className='row'>
                        <div className='col'>
                            <div className='row'>
                                <div className='col-sm-4'>
                                    <label className='profile-label'>School Name</label>
                                </div>
                                <div className='col'>
                                    <label className='profile-value'>{isLoading ? <SkeletonLoading customStyle={{width: "150px"}}/> : data.school ? data.school.name : <span>N/A</span>}</label>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-4'>
                                    <label className='profile-label'>Mentor Name</label>
                                </div>
                                <div className='col'>
                                    <label className='profile-value'>{isLoading ? <SkeletonLoading customStyle={{width: "150px"}}/> : data.mentor_first_name && data.mentor_last_name ? data.mentor_first_name + " " + data.mentor_last_name : <span>N/A</span>}</label>
                                </div>
                            </div>
                            {
                                data.assistance_mentor_first_name
                                    &&
                                    <div className='row'>
                                        <div className='col-sm-4'>
                                            <label className='profile-label'>Assistant Mentor Name</label>
                                        </div>
                                        <div className='col'>
                                            <label className='profile-value'>{isLoading ? <SkeletonLoading customStyle={{width: "150px"}}/> : data.assistance_mentor_first_name && data.assistance_mentor_last_name ? data.assistance_mentor_first_name + " " + data.assistance_mentor_last_name : <span>N/A</span>}</label>
                                        </div>
                                    </div>
                            }
                        </div>
                        <div className='col'>
                            <div className='row'>
                                <div className='col-sm-4'>
                                    <label className='profile-label'>School Location</label>
                                </div>
                                <div className='col'>
                                    <label className='profile-value'>{isLoading ? <SkeletonLoading customStyle={{width: "150px"}}/> : data.school ? data.school.city : <span>N/A</span>}</label>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-sm-4'>
                                    <label className='profile-label'>Active Session</label>
                                </div>
                                <div className='col'>
                                    <label className='profile-value'>{isLoading ? <SkeletonLoading customStyle={{width: "150px"}}/> : data.active_session_name ? data.active_session_name : <span>N/A</span>}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='profile-main-container'>
                    <h5>Contact Us</h5>
                    <hr className="profile-border" />
                    <div className='row'>
                        <div className='col'>
                            <div className='row'>
                                <div className='col-sm-4'>
                                    <label className='profile-label'>Email</label>
                                </div>
                                <div className='col'>
                                    <label className='profile-value'>business@fizrobotics.com</label>
                                </div>
                            </div>
                        </div>
                        <div className='col'>
                            <div className='row'>
                                <div className='col-sm-4'>
                                    <label className='profile-label'>Phone Number</label>
                                </div>
                                <div className='col'>
                                    <label className='profile-value'>+91 7879346284</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='profile-main-container'>
                    <div className='row'>
                        <div className='col'>
                            <h5>Change Password</h5>
                        </div>
                        <div className='col profile-header-right'>
                            <PrimaryButton
                                text="Change"
                                isLoading={isLoading}
                                onClick={handleChangePasswordButton}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default Profile;
